<template>
	<div class="qrcode">
		<!-- 二维码支付弹窗 -->
		<el-dialog
		  :title="$t('other.a154')"
		  :visible.sync="dialogVisible"
		  @close="$emit('update:show',false)"
		  :show='show'
		  width="60%"
		  >
		  <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
			  <div style="display: flex;margin-bottom: 20px;">
			     <el-radio v-model="paymethod" label="2" @change="getCode()">
			  	   <svg  class="icon" aria-hidden="true">
			  		   <use style="font-size: 30px;" xlink:href="#icon-zhifubao"></use>
			  	   </svg>
			     </el-radio>
			      <!-- <el-radio v-model="paymethod" label="1" @change="getCode()">
			  		<svg  class="icon01" aria-hidden="true">
			  			<use xlink:href="#icon-weixinzhifu"></use>
			  		</svg>
			  	</el-radio> -->
			      <el-radio v-model="paymethod" label="3" @change="getCode(3)">
			  		<img src="../../assets/img/Payssion.png" />
			  	</el-radio>
			      <el-radio v-model="paymethod" label="4" @change="getCode(4)">
			  		<img src="../../assets/img/ml.png" />
			  	</el-radio>
			      <el-radio v-model="paymethod" label="5" @change="getCode(5)">
			  		<img src="../../assets/img/yn.png" />
			  	</el-radio>
			      <el-radio v-model="paymethod" label="6" @change="getCode(6)">
			  		<img src="../../assets/img/flb.png" />
			  	</el-radio>
			  </div>
			  <div v-if="paymethod==3">
				<el-select size="mini" v-model="pmId" filterable @change="getCode" placeholder="">
                    <el-option
                        v-for="item in pmArr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
				<el-select size="mini" v-model="currency" filterable @change="getCode" placeholder="">
                    <el-option
                        v-for="item in currencyArr"
                        :key="item"
                        :label="item"
                        :value="item">
                    </el-option>
                </el-select>
			  </div>
			  <div v-if="paymethod==4">
				<el-select size="mini" v-model="pmId" filterable @change="getCode" placeholder="">
                    <el-option
                        v-for="item in mlArr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
			  </div>
			  <div v-if="paymethod==5">
				<el-select size="mini" v-model="pmId" filterable @change="getCode" placeholder="">
                    <el-option
                        v-for="item in ynArr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
			  </div>
			  <div v-if="paymethod==6">
				<el-select size="mini" v-model="pmId" filterable @change="getCode" placeholder="">
                    <el-option
                        v-for="item in flbArr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
			  </div>
			  <div >
			  	 <span class="qrcode-box" v-if="qrCode"><img style="width: 100%;" :src="qrCode" :alt="$t('other.a155')"></span>
			  </div>
			  <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;margin-top: 20px;">
				  <span style="font-size:18px;color: red;" v-if="paymethod==1||paymethod==2">{{$t('other.a156')}}{{payParams ? payParams.price : 0}}{{$t('other.a157')}}</span>
				  <span style="font-size:18px;color: red;" v-if="paymethod==3||paymethod==4||paymethod==5||paymethod==6">{{$t('other.a156')}}{{qrCodePrice}}</span>
				  <!-- <span style="font-size:14px;margin-top:10px" v-if="paymethod == 2">{{$t('other.a158')}}</span> -->
				   <span style="font-size:14px;margin-top:10px" v-if="paymethod == 1">{{$t('other.a159')}}</span>
			  </div>
		  </div>
		 
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">{{$t('other.a160')}}</el-button>
		    <el-button type="primary" @click="paySuccess">{{$t('other.a161')}}</el-button>
		  </span>
		</el-dialog>
		<!-- 查看销售情况弹窗 -->
		<el-dialog
		  :title="$t('other.a162')"
		  :visible.sync="salesVisible"
		  @close="$emit('update:showSales',false)"
		  :show='show'
		  width="50%"
		  >
		  <div class="wrapper-box">
			  <div style="100%">
			  				  <div class="block">
			  					 <el-date-picker
			  					   v-model="value7"
			  					   type="daterange"
			  					   size="mini"
			  					   align="right"
			  					   unlink-panels
			  					   :range-separator="$t('other.a47')"
			  					   :start-placeholder="$t('other.a45')"
			  					   :end-placeholder="$t('other.a46')"
								   @change="comfirm"
			  					   :picker-options="pickerOptions2">
			  					 </el-date-picker>
			  				   </div>	   
			  </div>
			  <div style="margin: 10px 0; color: #FA6F53;">{{$t('other.a163')}}{{intentoryturnover ? intentoryturnover :storeproductinventoryturnover}}</div>
			  <div id="chartLineBox" style="width: 600px;height: 300px;"></div>
		  </div>
		  <span slot="footer" class="dialog-footer">
		   <!-- <el-button @click="salesVisible = false">{{$t('other.a146')}}</el-button> -->
		    <el-button type="primary" @click="salesVisible=false">{{$t('other.a5')}} </el-button>
		  </span>
		</el-dialog>
	    <!-- 缺货提醒弹窗 -->
	    <el-dialog :title="storeData.storeName" :visible.sync="opp" center width="75%" @close="$emit('update:openQueHuochuankao',false)">
			<div style="width: 100%;">
				<div style="margin-bottom: 10px;display: flex;align-items: center;justify-content: space-between;">
					<div>
						{{$t('other.a164')}}
						<el-input
						size="mini"
						style="width: 180px;"
						value="number"
						  :placeholder="$t('other.a165')"
						  v-model="input10"
						  clearable>
						</el-input>
						 <el-button 
						 style="margin-left: 10px;" 
						 size="mini" type="primary"
						 @click="setPeriod()"
						 >{{$t('other.a166')}}</el-button>
						<el-checkbox style="padding-left: 10px;" @change="setPeriod()" v-model="radio">{{$t('other.a167')}}</el-checkbox>
						<!-- <span style="margin-left: 10px;color: red;cursor: pointer;" @click="exportXml()">{{$t('other.a72')}}</span> -->
					</div>
				</div>
					<el-table 
					:data="outOfstockReminder" 
					height="400px" 
					ref="multipleTable"
					@selection-change="handleSelectionChange"
					border>
						<el-table-column
						  type="selection"
						  width="55">
						</el-table-column>
						<el-table-column property="name" :label="$t('other.a66')" width="60" :show-overflow-tooltip="true">
							<template scope="scope">
								<el-popover placement="top-start" title="" trigger="hover">
									<img :src="scope.row.storeItem.image" style="width: 150px;height: 150px" />
									<img slot="reference" :src="scope.row.storeItem.image" style="width: 30px;height: 30px">
								</el-popover>
							</template>
						</el-table-column>
						<!-- <el-table-column property="storeItem.itemName" :label="$t('other.a179')"  :show-overflow-tooltip="true"></el-table-column> -->
						<el-table-column property="storeItem.skuName" label="sku"  :show-overflow-tooltip="true"></el-table-column>
						<el-table-column :label="$t('other.a168')" sortable :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.needStock01}}</span>
							</template>
						</el-table-column >
						<el-table-column :label="$t('other.a169')" sortable :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.nowStock}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a170')" sortable :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.shippedStock}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a171')" sortable :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.salesAvg01}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a172')" sortable :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.dayOfShip}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a173')" sortable :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.sevenday_estimatedSales}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a174')" sortable :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.fourteenday_estimatedSales}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a175')" sortable :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.thirty_estimatedSales}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a176')" :show-overflow-tooltip="true" sortable>
							<template scope="scope">
								<span>{{scope.row.daysAvailableSale}}{{$t('other.a177')}}</span>
							</template>
						</el-table-column>
					</el-table>
			</div>
			<span slot="footer" class="dialog-footer">
			<div style="width: 100%;display: flex;justify-content: flex-end;">
				<el-button  @click="createPurchase" type="primary">{{$t('other.a178')}}</el-button>
				<el-button  @click="opp=false" type="primary">{{$t('other.a5')}} </el-button>
			</div>
			  
			</span>
		
		</el-dialog>

		<!-- 滞销提醒 -->
		<el-dialog :title="unsalableData.storeName" :visible.sync="sluginreminderCopy" center width="60%" @close="$emit('update:sluginreminder',false)">
			<div style="width: 100%;">
					<el-table 
					:data="unsalableData.list" 
					height="400px" 
					ref="multipleTable"
					:default-sort = "{prop: 'inventoryTurnover', order: 'descending'}"
					@selection-change="handleSelectionChange"
					border>
						<el-table-column
						  type="selection"
						  width="55">
						</el-table-column>
						<el-table-column property="name" :label="$t('other.a66')" width="60" :show-overflow-tooltip="true">
							<template scope="scope">
								<el-popover placement="top-start" title="" trigger="hover">
									<img :src="scope.row.storeItem.image" style="width: 150px;height: 150px" />
									<img slot="reference" :src="scope.row.storeItem.image" style="width: 30px;height: 30px">
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column property="storeItem.itemName" sortable :label="$t('other.a179')"  :show-overflow-tooltip="true"></el-table-column>
						<el-table-column property="storeItem.skuName" sortable label="sku"  :show-overflow-tooltip="true"></el-table-column>
						<el-table-column :label="$t('other.a169')" property="nowStock" sortable :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.nowStock}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a170')" property="shippedStock" sortable :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.shippedStock}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a180')" property="inventoryTurnover" sortable :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{scope.row.inventoryTurnover.toFixed(2)}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a181')" property="lastTime" sortable :show-overflow-tooltip="true">
							<template scope="scope">
								<span>{{getTime(scope.row.lastTime)}}</span>
							</template>
						</el-table-column>
						
					</el-table>
			</div>
			<span slot="footer" class="dialog-footer">
			<div style="width: 100%;display: flex;justify-content: flex-end;">
				
				<el-button  @click="sluginreminderCopy=false" type="primary">{{$t('other.a5')}} </el-button>
			</div>
			  
			</span>
		
		</el-dialog>
	
	    <!-- 商店销售情况 -->
		<el-dialog
	      :title="$t('other.a182')"
	      :visible.sync="ttp"
	      @close="$emit('update:shopsalesVisible',false)"
	      :show='show'
	      width="50%"
	      >
	      <div class="wrapper-box">
	    	  <div style="100%">
	    	  				  <div class="block">
	    	  					 <el-date-picker
	    	  					   v-model="value7"
	    	  					   type="daterange"
	    	  					   size="mini"
	    	  					   align="right"
	    	  					   unlink-panels
	    	  					   :range-separator="$t('other.a47')"
	    	  					   :start-placeholder="$t('other.a45')"
	    	  					   :end-placeholder="$t('other.a46')"
	    						   @change="comfirm"
	    	  					   :picker-options="pickerOptions2">
	    	  					 </el-date-picker>
	    	  				   </div>	   
	    	  </div>
	    	  <div id="chartLineBox" style="width: 600px;height: 300px;"></div>
	      </div>
	      <span slot="footer" class="dialog-footer">
	       <!-- <el-button @click="salesVisible = false">{{$t('other.a146')}}</el-button> -->
	        <el-button type="primary" @click="ttp=false">{{$t('other.a5')}} </el-button>
	      </span>
	    </el-dialog>
		
		<!-- 仓库产品的库存日志 -->
		<el-dialog
		  :title="$t('storeManagement.thbjv')"
		  :visible.sync="In_stockDialog"
		  @close="$emit('update:instockdia',false)"
		  :show='show'
		  width="60%"
		  >

		  <div style="width:100%">
			  <div style="margin-bottom:20px;">
			  <el-date-picker
					v-model="value6"
					type="daterange"
					size="mini"
					align="right"
					unlink-panels
					value-format="yyyy-MM-dd"
					:range-separator="$t('other.a47')"
					:start-placeholder="$t('other.a45')"
					:end-placeholder="$t('other.a46')"
					@change="getStoreOperateRecordBytime()"
					:picker-options="pickerOptions2">
				</el-date-picker>
				<el-select style="margin-left:25px" size="mini" @change="getStoreOperateRecordBytime()" v-model="rechargeValue" :placeholder="$t('other.a50')">
					<el-option
					v-for="item in rechargeOption"
					:key="item.value"
					:label="item.label"
					:value="item.value">
					</el-option>
				</el-select>
				
				<el-select style="margin-left:25px" size="mini" @change="getStoreOperateRecordBytime()" v-model="typeOrder" :placeholder="$t('other.a50')">
					<el-option
					v-for="item in typeOrderOption"
					:key="item.value"
					:label="item.label"
					:value="item.value">
					</el-option>
				</el-select>

				<span style="margin-left:25px;margin-right:20px;">{{$t('storeManagement.kihk')}}：{{distrbutionOrderNum}}</span>
				 <el-button type="primary" @click="vhjkdnfl()">{{$t('other.a183')}}</el-button>
		  </div>
		  <div>
			  <el-table  size="mini" :data="storeoperaterecord" border height="400px" >
				<el-table-column
					:label="$t('storeManagement.ponkn')"
					>
					<template slot-scope="props">
						<span>{{props.row.decStock > 0 ? "-" + props.row.decStock : "+"+Math.abs(props.row.decStock)}}</span>
					</template>
				</el-table-column>
				<el-table-column
					:label="$t('storeManagement.dfggjk')"
					>
					<template slot-scope="props">
						<span>{{props.row.ordersn}}</span>
					</template>
				</el-table-column>
				<el-table-column 
					:label="$t('storeManagement.kgnmv')"
					>
						<template slot-scope="props">
						<span>{{getTime(props.row.createTime)}}</span>
						</template>
				</el-table-column>
				<el-table-column
					prop="newStock"
					:label="$t('storeManagement.fihgk')">
				</el-table-column>
				<el-table-column 
					:label="$t('other.a184')"
					>
						<template slot-scope="props">
						<span v-if="props.row.agency_user_id&&props.row.agency_user_id!=''">{{$t('other.a185')}}</span>
						<span v-else-if="props.row.platform=='DXS'">{{$t('other.a186')}}</span>
						<span v-else>{{$t('other.a187')}}</span>
						</template>
				</el-table-column>
			  </el-table>
		  </div>
		  <div class="block" style="text-align: right; margin: 10px 0 0 0;">
			     <el-pagination
				   size="mini"
			       @size-change="handleSizeChange"
			       @current-change="handleCurrentChange"
			       :current-page="currentPage4"
			       :page-sizes="[15, 20, 30, 50]"
			       :page-size="pagesize"
			       layout="total, sizes, prev, pager, next, jumper"
			       :total="storeoperaterecordcount">
			     </el-pagination>
			</div>
		  </div>
		  
		 <span slot="footer" class="dialog-footer">
			
				 <el-button type="primary" @click="In_stockDialog=false">{{$t('storeManagement.oooou')}}</el-button>
		  <!-- <el-button @click="salesVisible = false">{{$t('other.a146')}}</el-button> -->
		   
		 </span>
		    
		  
		   
		 
		</el-dialog>
		<!-- 商品绑定信息 -->
		<el-dialog
			:title="$t('other.a188')"
			:visible.sync="dialogTableVisible" 
			@close="$emit('update:openBoundDetail',false)" 
			width="80%"
			>
			<div style="width:100%;display:flex-direction:clounm">
				<div style="text-align:right;margin-bottom:15px"><el-button type="primary" @click="goTobound()">{{$t('other.a189')}}</el-button></div>
				<div>
					<el-table :data="bindItemList01" border height="500px" >
				<el-table-column width="80" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-popover placement="top-start" title="" trigger="hover">
							<img :src="scope.row.image" alt="" style="width: 150px;height: 150px">
							<img slot="reference" :src="scope.row.image" style="width: 30px;height: 30px">
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column  :label="$t('userStoreItems').bindItem.shopName"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{scope.row.shopName}} </span>
					</template>
				</el-table-column>
			
				<el-table-column property="itemSku" label="sku"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{scope.row.itemSku}}</span>
					</template>
				</el-table-column>
				<el-table-column property="itemSku" :label="$t('other.a190')"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{ scope.row.isPreOrder ? $t('other.a191') : $t('other.a192')}}</span>
					</template>
				</el-table-column>
				<el-table-column  :label="$t('userStoreItems').bindItem.operate"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-button type="danger" @click="jiebang(scope.row,scope.$index)">{{$t('other.a193')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogTableVisible = false">{{$t('other.a5')}}</el-button>
			</span>
			</el-dialog>
					
	</div>
</template>

<script>
	import echarts from 'echarts'
	import userStoreItems from '../../api/moudles/userStoreItems'
	import utils from '../../utils/utils.js'
	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	  export default {
		name:"QrcodeDialog",
	    data() {
	      return {
			pmId:'fpx_my',
			pmArr:[{label:'FPX',value:'fpx_my'},{label:'eNets',value:'enets_sg'},{label:'PayNow',value:'paynow_sg'},
			{label:'E-banking',value:'ebanking_th'},{label:'Doku',value:'doku_id'},{label:'ATM',value:'atm_id'},
			{label:'Alfamart',value:'alfamart_id'},{label:'Dragonpay',value:'dragonpay_ph'},{label:'Globe Gcash',value:'gcash_ph'},
			{label:'CherryCredits',value:'cherrycredits'},{label:'MOLPoints',value:'molpoints'},{label:'MOLPoints card',value:'molpointscard'},
			{label:'Alipay',value:'alipay_cn'},{label:'Tenpay',value:'tenpay_cn'},{label:'Unionpay',value:'unionpay_cn'},
			{label:'Gash',value:'gash_tw'},{label:'UPI',value:'upi_in'},{label:'Indian Wallets',value:'wallet_in'},
			{label:'India Netbanking',value:'ebanking_in'},{label:'India Credit/Debit Card',value:'bankcard_in'},{label:'South Korea Credit Card',value:'creditcard_kr'},
			{label:'South Korea Internet Banking',value:'ebanking_kr'},{label:'KakaoPay',value:'kakaopay_kr'},{label:'PAYCO',value:'payco_kr'},
			{label:'SSG Pay',value:'ssgpay_kr'},{label:'Samsung Pay',value:'samsungpay_kr'},{label:'onecard',value:'onecard'},
			{label:'Fawry',value:'fawry_eg'},{label:'Santander Rio',value:'santander_ar'},{label:'Pago Fácil',value:'pagofacil_ar'},
			{label:'Rapi Pago',value:'rapipago_ar'},{label:'bancodobrasil',value:'bancodobrasil_br'},{label:'itau',value:'itau_br'},
			{label:'Boleto',value:'boleto_br'},{label:'bradesco',value:'bradesco_br'},{label:'caixa',value:'caixa_br'},
			{label:'Santander',value:'santander_br'},{label:'BBVA Bancomer',value:'bancomer_mx'},{label:'Santander',value:'santander_mx'},
			{label:'oxxo',value:'oxxo_mx'},{label:'SPEI',value:'spei_mx'},{label:'redpagos',value:'redpagos_uy'},
			{label:'Abitab',value:'abitab_uy'},{label:'Banco de Chile',value:'bancochile_cl'},{label:'RedCompra',value:'redcompra_cl'},
			{label:'WebPay plus',value:'webpay_cl'},{label:'Servipag',value:'servipag_cl'},{label:'Santander',value:'santander_cl'},
			{label:'Efecty',value:'efecty_co'},{label:'PSE',value:'pse_co'},{label:'BCP',value:'bcp_pe'},
			{label:'Interbank',value:'interbank_pe'},{label:'BBVA',value:'bbva_pe'},{label:'Pago Efectivo',value:'pagoefectivo_pe'},
			{label:'BoaCompra',value:'boacompra'},{label:'QIWI',value:'qiwi'},{label:'Yandex.Money',value:'yamoney'},
			{label:'Webmoney',value:'webmoney'},
			{label:'Bank Card(Yandex.Money)',value:'yamoneyac'},{label:'Cash (Yandex.Money)',value:'yamoneygp'},{label:'Moneta',value:'moneta_ru'},
			{label:'Alfa-Click',value:'alfaclick_ru'},{label:'Promsvyazbank',value:'promsvyazbank_ru'},{label:'Faktura',value:'faktura_ru'},
			{label:'Russia Bank transfer',value:'banktransfer_ru'},{label:'Turkish Credit/Bank Card',value:'bankcard_tr'},{label:'ininal',value:'ininal_tr'},
			{label:'bkmexpress',value:'bkmexpress_tr'},{label:'Turkish Bank Transfer',value:'banktransfer_tr'},{label:'Paysafecard',value:'paysafecard'},
			{label:'Sofort',value:'sofort'},{label:'Giropay',value:'giropay_de'},{label:'EPS',value:'eps_at'},
			{label:'Bancontact/Mistercash',value:'bancontact_be'},{label:'Dotpay',value:'dotpay_pl'},{label:'P24',value:'p24_pl'},
			{label:'PayU',value:'payu_pl'},{label:'PayU',value:'payu_cz'},{label:'iDeal',value:'ideal_nl'},
			{label:'Multibanco',value:'multibanco_pt'},{label:'Neosurf',value:'neosurf'},{label:'Polipayment',value:'polipayment'},],
			mlArr:[{label:'FPX',value:'fpx_my'},{label:'Boost',value:'boost_my'},{label:'Touchngo',value:'touchngo_my'},{label:'Grabpay',value:'grabpay_my'}],
			ynArr:[{label:'VietQR',value:'vietqr_vn'},{label:'9Pay',value:'9pay_vn'}],
			flbArr:[{label:'Grabpay',value:'grabpay_ph'},{label:'InstaPay',value:'instapay_ph'},{label:'PesoNet',value:'pesonet_ph'}],
			currency:'AED',
			currencyArr:['AED','AUD','BDT','BGN','BHD','BRL','CAD','CHF','CLP','CNY','COP','CZK','DKK','EGP','EUR','GBP',
			'HKD','HRK','HUF','IDR','ILS','INR','JPY','KRW','KWD','MAD','MMK','MXN','MYR','NGN','NOK','NZD','OMR','PEN',
			'PHP','PKR','PLN','QAR','RBK','RON','RUB','SAR','SEK','SGD','THB','TRY','TWD','USD','UYU','VND','ZAR'],
			xuehuolist01:[],
			radio:false,
			rechargeValue:null,
			typeOrder:null,
			typeOrderOption:[{
				value:null,
				label:this.$t('other.a194')
			},{
				value:1,
				label:this.$t('other.a185')
			},{
				value:2,
				label:this.$t('other.a186')
			},{
				value:3,
				label:this.$t('other.a187')
			}],
			rechargeOption:[{
				value:null,
				label:this.$t('other.a195')
			},{
				value:0,
				label:this.$t('other.a196')
			},{
				value:1,
				label:this.$t('other.a197')
			},{
				value:2,
				label:this.$t('other.a198')
			},{
				value:3,
				label:this.$t('other.a199')
			},{
				value:4,
				label:this.$t('other.a200')
			},{
				value:5,
				label:this.$t('other.a201')
			},],
			deviceFormData:[],
			page:0,
			currentPage4:1,
			pagesize:50,//当前显示的数量50条
	        dialogVisible: this.show,
			multipleSelection:[],
			input10:7,
			quehuotixin:this.$t('other.a202'),
			unsalableTitle:this.$t('other.a203'),
			sluginreminderCopy:false,
			paymethod:'2',
			bindItemList01:[],
			warehouseList:[],
			dialogTableVisible:false,
			warehouseId:'',
			salesVisible:this.showSales,
			opp:this.openQueHuochuankao,
			ttp:this.shopsalesVisible,
			In_stockDialog:this.instockdia,
			pickerOptions2: {
			          shortcuts: [{
			            text: this.$t("other.a130"),
			            onClick(picker) {
			              const end = new Date();
			              const start = new Date();
			              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
			              picker.$emit('pick', [start, end]);
			            }
			          }, {
			            text: this.$t("other.a131"),
			            onClick(picker) {
			              const end = new Date();
			              const start = new Date();
			              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
			              picker.$emit('pick', [start, end]);
			            }
			          }, {
			            text: this.$t("other.a132"),
			            onClick(picker) {
			              const end = new Date();
			              const start = new Date();
			              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
			              picker.$emit('pick', [start, end]);
			            }
			          }]
			        },
			        value6: [],
			        value7: '',
					options:{
						tooltip: {              //设置tip提示
						                trigger: 'axis'
						            },
						            
						            legend: {               //设置区分（哪条线属于什么）
						                data:[this.$t("other.a204"),this.$t("other.a205")]
						            },
						            color: ['#8AE09F', '#FA6F53'],       //设置区分（每条线是什么颜色，和 legend 一一对应）
						            xAxis: {                //设置x轴
						                type: 'category',
						                boundaryGap: false,     //坐标轴两边不留白
						                data: [],
						                name: this.$t("other.a206"),           //X轴 name
						                nameTextStyle: {        //坐标轴名称的文字样式
						                    color: '#FA6F53',
						                    fontSize: 16,
						                    padding: [0, 0, 0, 20],
											
						                },
						                axisLine: {             //坐标轴轴线相关设置。
						                    lineStyle: {
						                        color: '#FA6F53',
												width:'600px'
						                    }
						                }
						            },
						            yAxis:[
										{
										    name: this.$t("other.a207"),
										    nameTextStyle: {
										        color: '#FA6F53',
										        fontSize: 16,
										        padding: [0, 0, 10, 0]
										    },
										    axisLine: {
										        lineStyle: {
										            color: '#FA6F53',
										        }
										    },
										    type: 'value'
										},
										{
										    name: this.$t("other.a205"),
										    nameTextStyle: {
										        color: '#8AE09F',
										        fontSize: 16,
										        padding: [0, 0, 10, 0]
										    },
										    axisLine: {
										        lineStyle: {
										            color: '#8AE09F',
										        }
										    },
										    type: 'value'
										},
										
									],
						            series: [
						              {
						                name: this.$t("other.a205"),
						                data:  [],
										yAxisIndex: 1,
						                type: 'line',               // 类型为折线图
						                lineStyle: {                // 线条样式 => 必须使用normal属性
						                    normal: {
						                        color: '#8AE09F',
						                    }
						                },
						              },
						              {
						                name: this.$t("other.a204"),
						                data: [],
						                type: 'line',
						                lineStyle: {
						                    normal: {
						                        color: '#FA6F53',
						                    }
						                },
						              }
						          ]

					},
					chartsline:null,
					payParamsCopy:this.payParams,
					quehuoList:[]
	      };
	    },
		
		computed: {
				...mapState({
					userId: state => state.shopaccess.userInfo.userId,
					salesInfo:state => state.mygoods.salesInfo,
					intentoryturnover:state => state.mygoods.intentoryturnover,
					xuehuoInfo:state => state.userStoreItems.xuehuoInfo,
					storeSalesInfo:state => state.userStoreItems.storeSalesInfo,
					storeproductinventoryturnover:state => state.userStoreItems.storeproductinventoryturnover,
					storeoperaterecord:state => state.userStoreItems.storeoperaterecord,
					storeoperaterecordcount:state => state.userStoreItems.storeoperaterecordcount,
					slugInReminder:state => state.userStoreItems.slugInReminder,

					unsalable:state => state.userStoreItems.unsalable,

				}),

				distrbutionOrderNum(){
					let num=0
					if(this.storeoperaterecord){

						this.storeoperaterecord.forEach(p => {
							if(p.type == 1){
								num+=p.decStock
							}
						})
					}

					return num
				},


				stockReminder(){//缺货提醒
					console.log(this.xuehuoInfo)
					let list=[]
				
					
					this.quehuotixin=this.storeData.storeName
					
					
					return list
				}
				
			},
		props:{
			payParams:{
				type:Object,
				default:() => {}
			},

			outOfstockReminder:{
				type:Array,
				default:() => []
			},

			storeData:{
				type:Object,
				default() {
					return {
						storeName:this.$t('other.a202')
					}
				}
			},

			unsalableData:{
				type:Object,
				default() {
					return {
						storeId:null,
						storeName:this.$t('other.a208'),
						list:[]
					}
				}
			},

			show:{
				type:Boolean,
				default:false
			},
			showSales:{
				type:Boolean,
				default:false
			},
			qrCode:{
				type:String,
				default:' '
			},
			qrCodePrice:{
				type:String,
				default:' '
			},
			salesItem:{
				type:Object,
				default:() => {}
			},

			boundProductList:{
				type:Array,
				default:() => []
			},

			openQueHuochuankao:{
				type:Boolean,
				default:false
			},
			sluginreminder:{
				type:Boolean,
				default:false
			},
			shopsalesVisible:{
				type:Boolean,
				default:false
			},
			instockdia:{
				type:Boolean,
				default:false
			},
			maincusCode:{
				type:Number,
				default:0
			},

			openBoundDetail:{
				type:Boolean,
				default:false
			},
		},
		watch:{
			openBoundDetail(){
				console.log(111)
				this.dialogTableVisible=this.openBoundDetail
				
			},
			typeOrder(){
				this.page=0
			},
			rechargeValue(){
				this.page=0
			},
			outOfstockReminder(){
				console.log('outOfstockReminder',this.outOfstockReminder)
			},
			boundProductList(){
				console.log(this.boundProductList)
				this.bindItemList01=this.boundProductList.items
				
				
			},
			storeData(){
				console.log(this.storeData)
				this.warehouseId=this.storeData.storeId
				this.quehuotixin=this.stockReminder.length +this.$t('other.a208')+this.storeData.storeName
				this.unsalableTitle=this.storeData.storeName
			},
			radio(){
				this.GET_QUENTITY_OUT_OF_STOCK_01(this.radio)
			},
			instockdia(){
				this.In_stockDialog=this.instockdia
				this.getTimeFn()
			},
			shopsalesVisible(){
				this.ttp=this.shopsalesVisible
			},
			openQueHuochuankao(){
				// if(this.openQueHuochuankao){
				//    this.input10=JSON.parse(localStorage.getItem('userInfo')).shipDay
				//    this.SET_REPLENISHMENT_PREIOD({shipbyday:this.input10,onway:this.radio})
				// }
				this.opp=this.openQueHuochuankao
			},

			sluginreminder(){
				this.sluginreminderCopy=this.sluginreminder
			},
			salesInfo(){
				this.chartsline = echarts.init(document.getElementById('chartLineBox'));
				console.log(this.salesInfo)
				let ttp=null
				let arr=this.salesInfo.map(p => {
					ttp=p.createTime.indexOf('T')
					console.log(ttp)
					return p.createTime.slice(0,ttp)
				})
				let salesQuantity=this.salesInfo.map(p => {
					return p.sales
				})
				let salesTotal=this.salesInfo.map(p => {
					return p.saleroom
				})
				console.log(arr)
				this.options.xAxis.data=arr
				this.options.series[0].data=salesTotal
				this.options.series[1].data=salesQuantity
				this.chartsline.setOption(this.options)
			},
			storeSalesInfo(){
				this.chartsline = echarts.init(document.getElementById('chartLineBox'));
				console.log(this.storeSalesInfo)
				let ttp=null
				let arr=this.storeSalesInfo.map(p => {
					ttp=p.createTime.indexOf('T')
					console.log(ttp)
					return p.createTime.slice(0,ttp)
				})
				let salesQuantity=this.storeSalesInfo.map(p => {
					return p.sales
				})
				let salesTotal=this.storeSalesInfo.map(p => {
					return p.saleroom
				})
				console.log(arr)
				this.options.xAxis.data=arr
				this.options.series[0].data=salesTotal
				this.options.series[1].data=salesQuantity
				this.chartsline.setOption(this.options)
			},
			show(){
				this.dialogVisible=this.show
			},
			showSales(){
				if(!this.salesVisible){
					this.value7=''
					this.SET_SUCCESS_ERROR_NULL()
					this.GET_DATA_STATUS_COLSE()
					
				}
				this.salesVisible=this.showSales
			},
			dialogVisible(){
				if(!this.dialogVisible){
					this.paymethod='2'
					this.REMOVE_STATE_T()
					this.REMOVE_STATE_R()
					this.REMOVE_STATE_P()
				}
			}
			
			
		},
		created(){
			this.getTimeFn()
			this.getStore()
			
		},
	
	    methods: {
			...mapActions('mygoods', [
				'getItemSales',
				'getInventoryTurnover',
				
			
			]),
			...mapActions('recharge', [
				'createPayorderBywechat',
				'createOrderalipay',
				'createPayorderByPayssion'
			]),
			...mapActions('userStoreItems', [
				'getStoreSales',
				'getStoreProductInventoryTurnover',
				'getInstockoperaterecore'
				
				]),
	      ...mapMutations('recharge', [
	      	'REMOVE_STATE_T',
			'REMOVE_STATE_R',
			'REMOVE_STATE_P'
	      ]),
		  
		  ...mapMutations('userStoreItems', [
		  	'SET_REPLENISHMENT_PREIOD',
			'GET_DATA_STATUS_COLSE',
			'SET_COUNT_QUEHUO',
			'GET_QUENTITY_OUT_OF_STOCK_01'
		  ]),
		  ...mapMutations('mygoods', [
		  	'GET_CURCODE_LIST_NULL',
		  	'SET_SUCCESS_ERROR_NULL',
		  ]),

		  kvhmf0lk(){
			  console.log(this.stockReminder)
			  this.storeData.storeName=this.warehouseList.find(item => item.value === this.warehouseId).label
				// this.quehuotixin=this.stockReminder.length +this.$t('other.a208')+this.storeData.storeName
			  
			  this.storeData.storeId=this.warehouseId
		  },

		  goTobound(){
			  this.$router.push({path:'/binditemsTab',query:{cusCode:this.boundProductList.cusCode,component:'products'}})
			  this.dialogTableVisible=false
			  
		  },

		  jiebang(item,index){
			this.$confirm(this.$t('other.a209'), this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a145'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
			}).then(() => {
				
				userStoreItems
				.jiebanItems(item) 
				.then(res => {
					
					if(res.code === 200) {
						this.$message.success(this.$t('other.a210'))
						this.bindItemList01.splice(index,1)
					}else{
						this.$message.warning(res.msg)
					}
				})
		
			})
			
		
		},

		  paySuccess(){
			  this.dialogVisible=false
			  this.$emit('refreshPoint')
		  },
		  
		  
		  exportXml(){
			 
			  		let arr = this.quehuoList
					console.log(arr)
			  		let csvlist = []
			  		if (!arr.length) {
			  			this.$message.error(this.$t('other.a152'))
			  			return
			  		}
			  		arr.forEach(p => {
			  			csvlist.push(p)
			  		})
			  		let ttp = csvlist.map(p => {
			  			return {
							'店铺名称': p.storeItem.shopName,
			  				'商品名称': p.storeItem.itemName,
			  				'sku': p.storeItem.skuName,
			  				'建议采购数': p.needStock01,
			  				'现有数量': p.nowStock,
							'在途数量':p.shippedStock,
							'平均销量/天':p.salesAvg01,
							'补货周期':p.dayOfShip
			  			}
			  
			  		})
			  		utils.exportExcel_quehuo(ttp)
			  	
			  
		  },
		  
		  getCode(index){
			  if(this.paymethod == 1) {
				  console.log('微信支付')
					this.REMOVE_STATE_R()//停止支付宝轮询
					this.REMOVE_STATE_P()//停止Payssion轮询
					this.createPayorderBywechat({
						userId:this.payParams.userId,
						rechargeId:this.payParams.rechargeId,
						userId:this.userId
					}) 		
			  }else if(this.paymethod == 2){
				  console.log('支付宝')
				  this.REMOVE_STATE_T()//停止微信支付轮询
					this.REMOVE_STATE_P()//停止Payssion轮询
				  this.createOrderalipay({
						userId:this.payParams.userId,
						rechargeId:this.payParams.rechargeId,
						userId:this.userId
				  }) 		
			  }else if(this.paymethod == 3||this.paymethod == 4||this.paymethod == 5||this.paymethod == 6){
				  console.log(index)
				  if(index == 3){
					this.pmId = 'fpx_my'
				  }else if(index == 4){
					this.pmId = 'fpx_my'
					}else if(index == 5){
					this.pmId = 'vietqr_vn'
					}else if(index == 6){
					this.pmId = 'grabpay_ph'
					}
				  this.REMOVE_STATE_T()//停止微信支付轮询
				  this.REMOVE_STATE_R()//停止支付宝轮询
				  this.createPayorderByPayssion({
						amount:this.payParams.price,
						userId:this.userId,
						// userId:this.payParams.userId,
						orderId:this.payParams.rechargeId,
						currency:this.paymethod == 3?this.currency:this.paymethod == 4?'MYR':this.paymethod == 5?'VND':'PHP',
						pmId:this.pmId,
						pc: false,
				  }) 		
			  }
		  },
		  getStoreOperateRecordBytime(){
			  console.log(this.rechargeValue)
			 
			  let params={
			  	cusCode:this.maincusCode,
			  	end:utils.CurdateAddoneday(this.value6[1]),
			  	start:this.value6[0],
			  	offset:this.pagesize,
				type:this.rechargeValue,
				typeOrder:this.typeOrder,
			  	page:this.page,
			  	userId:this.userId
			  }
			  this.getInstockoperaterecore(params)
		  },

		  vhjkdnfl(){
			// let arr=[]
			// 	this.storeoperaterecord.forEach(p => {
			// 			arr.push({
			// 				'cuscode':p.cuscode,
			// 				'库存变化': 0-p.decStock,
			// 				'变化原因':p.ordersn,
			// 				'变化时间':utils.renderTime(p.createTime),
			// 				'最新在仓库存':p.newStock,
			// 				'订单归属':p.agency_user_id&&p.agency_user_id!=''?'代理商订单':p.platform=='DXS'?'自建订单':'卖家订单'
			// 			})
				
			// 	})
				

			// 	let list=['cuscode','库存变化','变化原因','变化时间','最新在仓库存','订单归属']
			// 	console.log('arr',arr)
			// 	utils.exPortEXml(arr,list,list)
			// 	return
			  let params={
			  	cusCode:this.maincusCode,
			  	end:utils.CurdateAddoneday(this.value6[1]),
			  	start:this.value6[0],
			  	offset:this.storeoperaterecordcount+1,
				type:this.rechargeValue,
				typeOrder:this.typeOrder,
			  	page:0,
			  	userId:this.userId
			  }
			console.log(this.storeoperaterecord)

			  userStoreItems
			.getInstockoperaterecore(params)
			.then(res => {
				if(res.code === 200) {
					console.log('仓库库存操作日志',res.data)

					console.log(params)
					let arr=[]
				res.data.logList.forEach(p => {
						arr.push({
							'cuscode':p.cuscode,
							'库存变化': 0-p.decStock,
							'变化原因':p.ordersn,
							'变化时间':utils.renderTime(p.createTime),
							'最新在仓库存':p.newStock,
							'订单归属':p.agency_user_id&&p.agency_user_id!=''?'代理商订单':p.platform=='DXS'?'自建订单':'卖家订单'
						})
				
				})

				let list=['cuscode','库存变化','变化原因','变化时间','最新在仓库存','订单归属']
				console.log('arr',arr)
				utils.exPortEXml(arr,list,list)
					
				}
			})

			  console.log(params)
		  },
		  getConversion(arr){
			  let ttp=arr.filter( p => {
				  if(p.needStock01 > 0) {
					  return p
				  }
			  })
			 
			  this.SET_COUNT_QUEHUO(ttp.length)
			  this.quehuoList=ttp
			  return ttp
		  },
		  //创建采购单 
		  createPurchase(){
			  if(!this.multipleSelection.length) {
				  this.$message.error(this.$t('other.a211'))
				  return
			  }

			  let list=[]
			  this.multipleSelection.forEach(p => {
				  p.storeItem.variation={
							variationId: 0,
							name: '',
							stock: 0
						}
				 p.storeItem.num=Number(p.needStock01)
				  list.push(p.storeItem)
			  })

			  localStorage.setItem('purchaseItems',JSON.stringify(list))

			  console.log(this.multipleSelection)
			  this.$router.push({
				  path:'/purchaseDetail',
				  query:{
					  storeId:this.multipleSelection[0].storeItem.storeId
				  }
			  })
		
		  },
		  setPeriod(){
			  let params={
				  dayOfShip:this.input10,
				  type:this.radio
			  }
			  this.$emit('upataOutOfStack',params)
		  },
		  //查看销售商店，仓库销售情况时，选择日期后获取最新数据
		  comfirm(){
			  console.log(this.value7)
			  if(this.salesItem.cusCode) {//获取仓库的销售情况 
				  const  params={
						end:utils.getCurrnetTime(this.value7[1],false),
						start:utils.getCurrnetTime(this.value7[0],false),
						userId:this.salesItem.userId,
						type:this.rechargeValue,
						cusCode:this.salesItem.cusCode
					}
					this.getStoreSales(params)
					this.getStoreProductInventoryTurnover(params)
			  }else{//获取商店的销售情况
				  const params={
					  end:utils.getCurrnetTime(this.value7[1],false),
					  start:utils.getCurrnetTime(this.value7[0],false),
					  itemId:this.salesItem.itemId,
					  shopId:this.salesItem.shopId,
					  variationId:this.salesItem.variationId,
				  }
				  this.getItemSales(params)
				   this.getInventoryTurnover(params)
			  }
			
		  },
		  getStore(){
			 this.warehouseList= utils.getAllwarehouse().slice(1)
		  },
		  handleSelectionChange(val) {
			  this.multipleSelection = val;
			  console.log(this.multipleSelection)
		  },
		  toggleSelection(rows) {
			  if (rows) {
				rows.forEach(row => {
				  this.$refs.multipleTable.toggleRowSelection(row);
				});
			  } else {
				this.$refs.multipleTable.clearSelection();
			  }
			},
			getTime(date){
				if(date){
					return utils.renderTime(date)
				}else{
					return this.$t('other.a212')
				}
			},
			handleSizeChange(val) {
				this.pagesize=Number(`${val}`)
				console.log('每面显示的数量',this.pagesize);
				this.handleCurrentChange()
			},
		  handleCurrentChange(val) {
			  let num=Number(`${val}`)
			  this.page=(num-1)*this.pagesize
			
			let params={
				cusCode:this.storeoperaterecord[0].cuscode,
				end:utils.CurdateAddoneday(this.value6[1]),
				start:this.value6[0],
				offset:this.pagesize,
				type:this.rechargeValue,
				typeOrder:this.typeOrder,
				page:this.page,
				userId:this.userId
			}
			this.getInstockoperaterecore(params)
		  },
		  
		  getTimeFn() {
				this.value6[0]=utils.getRecentSevenDay(-7)
				this.value6[1]=utils.getRecentSevenDay(0)

				console.log('value6',this.value6)
				
		   },
		   formatDate(date) {
		         var myyear = date.getFullYear();
		         var mymonth = date.getMonth() + 1;
		         var myweekday = date.getDate();
		   
		         if (mymonth < 10) {
		           mymonth = "0" + mymonth;
		         }
		         if (myweekday < 10) {
		           myweekday = "0" + myweekday;
		         }
		         return myyear + "-" + mymonth + "-" + myweekday;
		       },
	
	    }
	  };
</script>

<style >
/* .v-modal{
	background: none;
	position: fixed;
	    left: 0;
	    top: 0;
	    width: 0;
	    height: 0;
	    opacity: 0;
} */
.qrcode-box{
	position: relative;
	display: inline-block;
	z-index: 9999999;

	width: 256px;
	height: 256px;
	
	
}

.icon{
	width: 82px !important;
}

.qrcode .el-dialog__body {
    padding: 10px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    display: flex;
    justify-content: center;
}

.qrcode .el-radio{
	    display: flex;
	    justify-content: center;
	    align-items: center;
}

</style>
